"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SwitchItem", {
  enumerable: true,
  get: function () {
    return _SwitchItem.default;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Switch.default;
  }
});
var _Switch = _interopRequireDefault(require("./Switch"));
var _SwitchItem = _interopRequireDefault(require("./SwitchItem"));